import makeStyles from '@mui/styles/makeStyles';

const pageStyles = makeStyles((theme) => ({
    container: {
        paddingBottom: '4rem',
    },
}));

export default pageStyles;
